<app-list-task [stages]="stages$ | async" [loading]="loading$ | async" [tasks]="tasks$ | async"
 (stageSelected$)="navigateToTask($event)">
</app-list-task>